import React from 'react';
import './Section.css';

/**
 * Reusable Section component for content sections
 * @param {string} variant - 'light' or 'dark' background
 * @param {boolean} reversed - Reverse layout order (image on left)
 * @param {string} className - Additional CSS classes
 * @param {React.ReactNode} children - Section content
 */
const Section = ({
  variant = 'light',
  reversed = false,
  className = '',
  children,
  id,
  ariaLabelledBy,
  ...props
}) => {
  const sectionClasses = [
    'section',
    `section--${variant}`,
    reversed ? 'section--reversed' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <section
      className={sectionClasses}
      id={id}
      aria-labelledby={ariaLabelledBy}
      {...props}
    >
      <div className="section-container">
        {children}
      </div>
    </section>
  );
};

export default Section;
